var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"page centered-container",attrs:{"id":"new-version-page"}},[_c('NewVersion')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }